import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LazyLoad from 'react-lazyload';
import DisplayComponent from '../BaseComponents/DisplayComponent';
import Link from '../Link/Link';
import Picture from './Picture';
import Header from '../Type/Header';

import './Tile.module.css';

class Tile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { mobile: false };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    this.setState({ mobile: window.innerWidth <= 640 });
  };

  render() {
    const {
      title,
      ctaText,
      image,
      imageAlt,
      themeColor,
      url,
      id,
      imageHeight,
      imageWidth,
      classes,
      tileStyle,
      lastChild,
      gradientOverlay
    } = this.props;
    const { mobile } = this.state;
    const imageRatio = (imageHeight / imageWidth) * 100;
    if (tileStyle === 'link_list' || tileStyle === 'link_list_gray') {
      return (
        <Link to={url} styleName="link-list-link">
          <div
            styleName={classNames(
              'tile',
              'link_list',
              `${lastChild ? 'last' : ''}`,
              `${tileStyle === 'link_list_gray' ? 'gray' : ''}`
            )}
          >
            <Picture largeImage={image} alt={imageAlt} />
            <p styleName="link-title">{title}</p>
            <p styleName="link-button">{ctaText}</p>
          </div>
        </Link>
      );
    }
    if (tileStyle === 'none') {
      return (
        <Link to={url} styleName="link-list-link">
          <div
            styleName={classNames(
              'tile link_list plain',
              `${lastChild ? 'last' : ''}`
            )}
          >
            <Picture largeImage={image} alt={imageAlt} />
            <p styleName="link-title">{title}</p>
            <p styleName="link-button">{ctaText}</p>
          </div>
        </Link>
      );
    }
    return (
      <LazyLoad offset={100} debounce={1} true>
        <Link className={classes} to={url}>
          {!mobile && (
            <div styleName="hoverfix">
              <div styleName="tile" className={`tile-${id}`}>
                <style
                  dangerouslySetInnerHTML={{
                    __html: `
                    .tile-${id} {background-image: linear-gradient(to bottom, rgba(71,71,77,0) 20%,rgba(71,71,77,0.7) 70%),  url(${image}); padding-top: 62% }
                    .tile-${id} .overlay {background-image: linear-gradient(to bottom, rgba(71,71,77,0.7) 20%,rgba(71,71,77,0.7) 70%),  url(${image});position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    transition: all 0.2s ease-in-out;
                    background-size: cover;
                    z-index: 1;}
                    .tile-${id}:hover .overlay{
                      opacity:0;
                    }
                    @media (min-width:641px) {
                      .tile-${id} {
                        padding-top: ${imageRatio}%
                      }
                    }
                  `
                  }}
                />
                <div styleName="copy">
                  <Header
                    level={5}
                    displayAs={5}
                    styles={{ color: themeColor }}
                  >
                    {title}
                  </Header>
                  <p style={{ color: '#5DB5FF' }}>
                    {ctaText}{' '}
                    <i
                      className="fl-arrow-right"
                      style={{ color: '#5DB5FF' }}
                    />
                  </p>
                </div>
                <div className="overlay" />
              </div>
            </div>
          )}
          {mobile && (
            <div styleName="tile">
              {gradientOverlay && <Picture largeImage={image} alt={imageAlt} />}
              <div styleName="copy">
                <Header level={5} displayAs={5}>
                  {title}
                </Header>
                <p style={{ color: '#5DB5FF' }}>
                  {ctaText}{' '}
                  <i className="fl-arrow-right" style={{ color: '#5DB5FF' }} />
                </p>
              </div>
            </div>
          )}
        </Link>
      </LazyLoad>
    );
  }
}

Tile.propTypes = {
  title: PropTypes.string,
  ctaText: PropTypes.string,
  themeColor: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  id: PropTypes.number,
  imageHeight: PropTypes.node,
  imageWidth: PropTypes.node,
  tileStyle: PropTypes.string,
  lastChild: PropTypes.bool,
  gradientOverlay: PropTypes.bool,
  classes: PropTypes.any
};

export default DisplayComponent(Tile);
